import React, { type ReactNode } from 'react';
import type {
	EnhancedUFOInteractionContextType,
	ReactProfilerTiming,
} from '@atlaskit/react-ufo/common';

const SsrRenderProfiler = ({
	children,
}: {
	children?: ReactNode | undefined;
	labelStack: ReactProfilerTiming['labelStack'];
	onRender: EnhancedUFOInteractionContextType['onRender'];
}) => {
	return <>{children}</>;
};
export default SsrRenderProfiler;
